import TIMSansThin from "../../assets/fonts/tim/TIMSansWeb-Thin.woff2";
import TIMSansThinItalic from "../../assets/fonts/tim/TIMSansWeb-ThinItalic.woff2";
import TIMSansLight from "../../assets/fonts/tim/TIMSansWeb-Light.woff2";
import TIMSansLightItalic from "../../assets/fonts/tim/TIMSansWeb-LightItalic.woff2";
import TIMSansRegular from "../../assets/fonts/tim/TIMSansWeb-Regular.woff2";
import TIMSansItalic from "../../assets/fonts/tim/TIMSansWeb-Italic.woff2";
import TIMSansMedium from "../../assets/fonts/tim/TIMSansWeb-Medium.woff2";
import TIMSansMediumItalic from "../../assets/fonts/tim/TIMSansWeb-MediumItalic.woff2";
import TIMSansBold from "../../assets/fonts/tim/TIMSansWeb-Bold.woff2";
import TIMSansBoldItalic from "../../assets/fonts/tim/TIMSansWeb-BoldItalic.woff2";
import TIMSansHeavy from "../../assets/fonts/tim/TIMSansWeb-Heavy.woff2";
import TIMSansHeavyItalic from "../../assets/fonts/tim/TIMSansWeb-HeavyItalic.woff2";

const DEFAULT_FONT_STACK = `'Montserrat', sans-serif`;

const TIM_SANS_FAMILY_NAME = "TIM Sans Web";

const timSansFontFaceCss = `
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansThin}) format('woff2');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansThinItalic}) format('woff2');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansLight}) format('woff2');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansLightItalic}) format('woff2');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansRegular}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansItalic}) format('woff2');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansMediumItalic}) format('woff2');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansBold}) format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansBoldItalic}) format('woff2');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansHeavy}) format('woff2');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: '${TIM_SANS_FAMILY_NAME}';
    src: url(${TIMSansHeavyItalic}) format('woff2');
    font-weight: 800;
    font-style: italic;
    font-display: swap;
  }
`;

function normalizeFontFamilyToken(token) {
  if (typeof token !== "string") return "";
  return token.trim().toLowerCase();
}

export function getWhitelabelFontConfig(fontFamilyToken) {
  const token = normalizeFontFamilyToken(fontFamilyToken);

  if (!token) {
    return {
      cssVarFontFamily: DEFAULT_FONT_STACK,
      fontFaceCss: "",
    };
  }

  if (token === "tim-sans") {
    return {
      cssVarFontFamily: `'${TIM_SANS_FAMILY_NAME}'`,
      fontFaceCss: timSansFontFaceCss,
    };
  }

  return {
    cssVarFontFamily: DEFAULT_FONT_STACK,
    fontFaceCss: "",
  };
}

